import * as R from 'ramda';
import { useMutation } from '@apollo/client';
import { useSavingStore } from '@@app/stores/savingStore.js';

// Seules les mutations de save font patienter le bouton « suivant »
const isSaveMutation = R.startsWith('save');

export const useCommitMutation = (mutation, { dataProp }) => {
  const [mutate, { loading, called }] = useMutation(mutation);
  const { startSave, endSave } = useSavingStore.getState();
  const tracksSaving = isSaveMutation(dataProp);

  const onFormSubmit = (input, done, opts = {}) => {
    if (tracksSaving) startSave();
    mutate({
      ...opts,
      variables: { input },
      onCompleted: (response) => {
        if (tracksSaving) endSave();
        const data = R.prop(dataProp, response);
        const { ok, error } = data;
        done(ok, error, R.omit(['ok', 'error'], data));
      },
      onError: (error) => {
        if (tracksSaving) endSave();
        done(false, JSON.stringify(error, null, 4));
      }
    });
  };

  return {
    onFormSubmit,
    loading,
    called
  };
};
